import { CreateCaseState } from './CreateCaseManager.types';

export const actionTypes = {
    SAVE_DATA: 'SAVE_DATA',
};

type Action = { type: any; payload?: any };

export const CreateCaseManagerReducer = (state: CreateCaseState, action: Action): CreateCaseState => {
    switch (action.type) {
        case actionTypes.SAVE_DATA:
            return { ...state, ...action.payload };
        default:
            return state;
    }
};
